import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Pure server-side pagination. `pagination` comes straight from
 * `response.pagination` — nothing is computed client-side.
 */
export default function ECGReportsPagination({ pagination, onPageChange }) {
  if (!pagination || pagination.total_pages <= 1) return null;

  const { page, total_pages, total_results, has_previous, has_next } = pagination;

  const pages = Array.from({ length: total_pages }, (_, i) => i + 1);

  return (
    <div className="flex flex-col items-center justify-between gap-3 border-t border-gray-200 px-4 py-3 sm:flex-row">
      <p className="text-sm text-gray-600">
        Page {page} of {total_pages} ({total_results} total items)
      </p>

      <div className="flex items-center gap-1">
        <button
          type="button"
          disabled={!has_previous}
          onClick={() => onPageChange(page - 1)}
          className="inline-flex items-center gap-1 rounded-lg border border-gray-300 bg-white
                     px-2.5 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50
                     disabled:cursor-not-allowed disabled:opacity-50"
        >
          <ChevronLeft className="h-4 w-4" />
          Previous
        </button>

        {pages.map((p) => (
          <button
            key={p}
            type="button"
            onClick={() => onPageChange(p)}
            className={`min-w-[2rem] rounded-lg px-2.5 py-1.5 text-sm font-medium ${
              p === page
                ? "bg-red-600 text-white"
                : "border border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
            }`}
          >
            {p}
          </button>
        ))}

        <button
          type="button"
          disabled={!has_next}
          onClick={() => onPageChange(page + 1)}
          className="inline-flex items-center gap-1 rounded-lg border border-gray-300 bg-white
                     px-2.5 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50
                     disabled:cursor-not-allowed disabled:opacity-50"
        >
          Next
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}